<template>
  <div class="details">
    <div class="top">
      <div class="top_left">
        {{ times }}
      </div>
      <el-button type="primary" plain @click="onSubmit()">保存</el-button>
    </div>
    <el-table id="table_count" ref="reftbale" :data="tableData" :row-key="rowKeyFun" style="width: 100%"
      height="calc(100vh - 200px)" v-loading="loading" element-loading-text="加载中"
      element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
      <el-table-column label="姓名" prop="mname" min-width="90" fixed="left"></el-table-column>
      <el-table-column label="操作" min-width="60" fixed="left">
        <template slot-scope="scope">
          <div>
            <div style="color: #4991ff; cursor: pointer" @click="onAmend(scope.row)">
              修改
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="排序" align="center">
        <template>
          <i class="el-icon-rank handle"></i>
        </template>
      </el-table-column>
      <el-table-column width="80" align="center" v-for="item in classesPlan" :key="item">
        <tamplate slot="header">
          <div style="
              height: 46px !important;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
            ">
            <div>
              {{
                item.mmdd == "周六" || item.mmdd == "周日"
                  ? item.mmdd.slice(1)
                  : item.weekday.slice(
                    item.weekday.length - 3,
                    item.weekday.length - 2
                  ) == 0
                    ? item.weekday.slice(
                      item.weekday.length - 2,
                      item.weekday.length - 1
                    )
                    : item.weekday.slice(
                      item.weekday.length - 3,
                      item.weekday.length - 1
                    )
              }}
            </div>
            <el-tooltip class="item" effect="dark" :content="item.holidays" placement="bottom">
              <div style="
                  width: 100%;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                ">
                {{ item.holidays }}
              </div>
            </el-tooltip>
          </div>
        </tamplate>
        <template slot-scope="scope">
          <div>
            <template v-for="items in scope.row.classesPlan">
              <div :key="items" v-if="item.weekday == items.weekday" style="xiala">
                <el-select :style="{ background: items.color, 'border-radius': '5px' }" v-model="items.type"
                  placeholder="请选择" @change="onSelect($event, scope.row, item)">
                  <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </template>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div>共 {{ total }} 条</div>
  </div>
</template>

<script>
import attendanceSection from "./attendanceSection.vue";
import Sortable from "sortablejs";
export default {
  data() {
    return {
      tableData: [],
      columns: [],
      options: [],
      classesPlan: [],
      pageNum: 1,
      total: "",
      pageSize: 20,
      id: "",
      loading: false,
      times: "",
      tableKey: new Date().getTime(),
      sortable: "",
    };
  },
  components: {
    attendanceSection,
  },
  created() {
    let query = this.$route.query;
    this.id = query.id;
    this.times = query.time.split("-").join("年") + "月";
    this.load();
    this.getOptionList();
  },
  mounted() {
    this.initSortable();
  },
  methods: {
    rowKeyFun(row) {
      return row.id;
    },
    initSortable() {
      let that = this;
      // 获取el-table DOM
      const el = document.querySelector(
        "#table_count .el-table__body-wrapper tbody"
      );
      new Sortable(el, {
        animation: 150,
        handle: ".handle",
        ghostClass: "blue-background-class",
        onEnd: function (/**Event*/ evt) {
          let newIndex = evt.newIndex; // 排序后的索引位置
          let oldIndex = evt.oldIndex; // 排序前的索引位置
          that.updateTableData(newIndex, oldIndex);
        },
      });
    },
    updateTableData(newIndex, oldIndex) {
      let arr = this.tableData.slice(); // 创建数据的副本;
      console.log(newIndex, oldIndex, arr);
      // 移动目标行
      const [movedItem] = arr.splice(oldIndex, 1); // 移除旧位置的项目
      arr.splice(newIndex, 0, movedItem); // 插入到新位置

      // 更新序列号
      arr.forEach((item, index) => {
        item.sequences = index + 1; // 更新序列号
      });
      this.tableData = arr;

      console.log(this.tableData);
    },
    load() {
      let q = {
        // pageSize: this.pageSize,
        // pageNum: this.pageNum,
      };
      this.loading = true;
      $utils.api.load(`/admin/system/plan/${this.id}`, q, "get").then((res) => {
        this.loading = false;
        if (res.code == 200) {
          let tableData = res.rows;
          this.total = res.total;
          tableData.forEach((item, index) => {
            item.classesPlan = JSON.parse(item.classesPlan);
            item.sequences = index + 1;
          });
          this.tableData = tableData;
          this.classesPlan = tableData[0].classesPlan;

          // this.$nextTick(() => {
          //   if (this.$refs.reftbale && this.$refs.reftbale.doLayout) {
          //     this.$refs.reftbale.doLayout();
          //   }
          // });
        }
      });
    },
    getOptionList() {
      let q = {};
      $utils.api.load("/admin/system/classes/list", q, "get").then((res) => {
        if (res.code == 200) {
          this.options = res.rows;
        }
      });
    },
    onEditList(tableList) {
      // let q = []
      this.loading = true;
      $utils.api.load("/admin/system/plan", tableList, "PUT").then((res) => {
        this.loading = false;
        if (res.code == 200) {
          $utils.toast.success("保存成功");
          this.load();
        }
      });
    },
    onSubmit() {
      let q = [];
      this.tableData.forEach((item, index) => {
        let a = {};
        a.classesDateId = item.classesDateId;
        a.id = item.id;
        a.mid = item.mid;
        a.mname = item.mname;
        a.sysClassesPlanVoList = item.classesPlan;
        a.sequences = item.sequences;
        q.push(a);
      });
      this.loading = true;
      $utils.api.load("/admin/system/plan", q, "PUT").then((res) => {
        this.loading = false;
        if (res.code == 200) {
          $utils.toast.success("保存成功");
          // window.location.reload();
          this.load();
        }
      });
    },
    onAmend(row) {
      console.log(row);
      this.$Modal.success({
        closable: true,
        title: "修改当前用户本月考勤组",
        width: "800px",
        height: "80px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <attendanceSection
              options={this.options}
              onAmendSubmit={(e) => this.amendSubmit(e, row)}
            />
          );
        },
      });
    },
    amendSubmit(id, row) {
      // console.log(id, row);
      let that = this;
      this.tableData.forEach((item) => {
        if (item.id == row.id) {
          item.classesPlan.forEach((items) => {
            items.type = id;
            that.options.forEach((itemss) => {
              if (id == itemss.id) {
                items.color = itemss.color;
              }
            });
          });
        }
      });
      this.$Modal.remove();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.pageNum = 1;
      this.load();
    },
    handleCurrentChange(currentSize) {
      this.pageNum = currentSize;
      this.load();
    },
    onSelect(e, row, col) {
      let that = this;
      // console.log(e, row, col);
      this.tableData.forEach((item) => {
        if (row.id == item.id) {
          // console.log(item);
          item.classesPlan.forEach((items) => {
            if (items.weekday == col.weekday) {
              that.options.forEach((itemss) => {
                if (itemss.id == e) {
                  items.color = itemss.color;
                }
              });
            }
          });
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.top {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .top_left {
    font-size: 20px;
    font-weight: 800;
  }

  .top_btn {
    width: 150px;
    height: 40px;
    background: #4991ff;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    border-radius: 10px;
  }
}

.details {
  /deep/ .active {
    background-color: #fff !important;
  }
}

/deep/.el-input--suffix .el-input__inner {
  padding: 0;
  padding-left: 10px;
}

/deep/.el-input__inner {
  border: none;
  background: transparent;
}

/deep/.el-input__icon {
  width: 20px;
}

/deep/.el-input__suffix {
  right: 0;
}

/deep/ .el-table__fixed-body-wrapper {
  top: 71px !important;
}

/deep/ .el-table__fixed-header-wrapper {
  height: 71px !important;
}

/deep/ .el-select-dropdown__wrap {
  max-height: 400px !important;
}
</style>
<style>
.el-select-dropdown__wrap {
  max-height: 400px !important;
}
</style>
